import React from 'react';
export function Footer() {
  return <footer className="bg-brand-text text-white/70 py-12 px-4 sm:px-6 text-sm" data-id="element-6">
      <div className="max-w-5xl mx-auto text-center space-y-6" data-id="element-7">
        <div className="font-heading font-bold text-2xl text-white mb-6" data-id="element-8">
          Método 2-2-2
        </div>

        <p className="max-w-3xl mx-auto leading-relaxed" data-id="element-9">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>

        <p className="max-w-3xl mx-auto leading-relaxed" data-id="element-10">
          DESCARGO DE RESPONSABILIDAD: Los resultados pueden variar de persona a
          persona. El Método 2-2-2 es un sistema de organización y planificación
          de comidas. No garantizamos resultados específicos ya que dependen de
          la implementación individual. La información proporcionada tiene fines
          educativos y no sustituye el consejo médico o nutricional profesional.
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 pt-6 border-t border-white/10" data-id="element-11">
          <a href="#" className="hover:text-white transition-colors" data-id="element-12">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-13">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-14">
            Contacto
          </a>
        </div>

        <div className="pt-4" data-id="element-15">
          &copy; {new Date().getFullYear()} Método 2-2-2. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}